import type {
	CollectionSortFilterOptions,
	MediaFilterOptions,
	RatingFilterOptions,
	StatusFilterOptions,
} from './collection.ts'

export const HOMEPAGE_PATHS = ['/collection', '/shuffle'] as const
export type HomepagePath = (typeof HOMEPAGE_PATHS)[number]

export interface ClientUser {
	_id: string
	discogsId?: number
	discogsToken?: string
	discogsTokenSecret?: string
	discogsUsername?: string
	discogsAvatarUrl?: string
	lastSeenAt?: string
	settings?: Settings
}

export type SavedFilterValue<T> = T | T[]

export interface ShuffleFilterDefaults {
	favoritesOnly: boolean
	folderId: SavedFilterValue<number> | null
	genre: SavedFilterValue<string> | null
	includeHidden: boolean
	media: SavedFilterValue<MediaFilterOptions>
	rating: SavedFilterValue<RatingFilterOptions> | null
	style: SavedFilterValue<string> | null
	yearFrom: number | null
	yearTo: number | null
}

export interface Settings {
	dimReleaseIfHiddenOff: boolean
	showCollectionValue: boolean
	skipShuffleAnimation: boolean
	defaultHideDurationMonths: number | null
	defaultCollectionSort: CollectionSortFilterOptions
	defaultFolderId: SavedFilterValue<number> | null
	defaultGenre: SavedFilterValue<string> | null
	defaultMedia: SavedFilterValue<MediaFilterOptions>
	defaultHistory: SavedFilterValue<StatusFilterOptions>
	defaultRating: SavedFilterValue<RatingFilterOptions> | null
	defaultStyle: SavedFilterValue<string> | null
	defaultYearFrom: number | null
	defaultYearTo: number | null
	defaultShuffleFilters?: ShuffleFilterDefaults | null
	homepage: HomepagePath
	lastSeenReleaseNotesId: string | null
	theme: 'dark' | 'light'
}

export function isHomepagePath(value: unknown): value is HomepagePath {
	return HOMEPAGE_PATHS.includes(value as HomepagePath)
}
